import React, { useEffect, useState } from "react";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faImage, faTimes } from "@fortawesome/free-solid-svg-icons";
const base_url = process.env.REACT_APP_API_URL;

const WithdrawHistory = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
  const [withdraw, setWithdraw] = useState([]);
  const [filteredWithdraw, setFilteredWithdraw] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [showImageModal, setShowImageModal] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // Filters
  const [searchText, setSearchText] = useState("");
  const [startDate, setStartDate] = useState(""); // format: yyyy-mm-dd
  const [endDate, setEndDate] = useState("");
  const [statusFilter, setStatusFilter] = useState(""); // "", "1", "0"

  // Toggle sidebar visibility
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  function formateT(params) {
    let result = params < 10 ? "0" + params : params;
    return result;
  }

  function timerJoin(params = "", addHours = 0) {
    let date = "";
    if (params) {
      date = new Date(Number(params));
    } else {
      date = new Date();
    }

    date.setHours(date.getHours() + addHours);

    let years = formateT(date.getFullYear());
    let months = formateT(date.getMonth() + 1);
    let days = formateT(date.getDate());

    let hours = date.getHours() % 12;
    hours = hours === 0 ? 12 : hours;
    let ampm = date.getHours() < 12 ? "AM" : "PM";

    let minutes = formateT(date.getMinutes());
    let seconds = formateT(date.getSeconds());

    return (
      years +
      "-" +
      months +
      "-" +
      days +
      " " +
      hours +
      ":" +
      minutes +
      ":" +
      seconds +
      " " +
      ampm
    );
  } 

  // Search text filter handler
  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  // Filter button handler
  const handleFilter = () => {
    const start = startDate ? new Date(startDate + "T00:00:00") : null;
    const end = endDate ? new Date(endDate + "T23:59:59") : null;

    const filtered = withdraw.filter((item) => {
      // Search filter on id_order or phone
      const matchesSearch =
        searchText === "" ||
        item.id_order.includes(searchText) ||
        item.phone.includes(searchText);

      // Parse DB time string "YYYY-MM-DD HH:mm:ss" to ISO "YYYY-MM-DDTHH:mm:ss"
      const itemTime = new Date(item.time.replace(" ", "T"));

      const matchesStart = start ? itemTime >= start : true;
      const matchesEnd = end ? itemTime <= end : true;

      // Status filter: "1" = Success, "0" = Reject
      const matchesStatus =
        statusFilter === "" ? true : String(item.status) === statusFilter;

      return matchesSearch && matchesStart && matchesEnd && matchesStatus;
    });

    setFilteredWithdraw(filtered);
  };

  const withdrawData = async () => {
    try {
      const auth = localStorage.getItem("admin");
      const response = await axios.post(
        base_url + "/api/webapi/admin/recharge",
        {
          auth,
        },
        {
          headers: {
            "content-type": "application/json",
          },
        }
      );

      const data = response?.data.datas4;
      if (response?.data.status) {
        // Fix the proof_image path by prepending the base_url if it's a relative path
        const dataWithImages = data.map(item => ({
          ...item,
          proof_image: item.proof_image 
            ? (item.proof_image.startsWith('/') ? base_url + item.proof_image : item.proof_image)
            : `/api/placeholder/400/300` // Placeholder for demo
        }));
        setWithdraw(dataWithImages);
        setFilteredWithdraw(dataWithImages);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
    setShowImageModal(true);
  };

  const closeImageModal = () => {
    setShowImageModal(false);
    setSelectedImage(null);
  };

  useEffect(() => {
    withdrawData();
  }, [refresh]);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      
      // On desktop, sidebar should always be "open"
      if (!mobile) {
        setIsSidebarOpen(true);
      }
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="wrapper">
      {/* Main Sidebar */}
      <AdminSidebar 
          isSidebarOpen={isSidebarOpen} 
          toggleSidebar={toggleSidebar} 
          isMobile={isMobile}
        />
        
        {/* Header - Pass mobile info */}
        <AdminHeader 
          toggleSidebar={toggleSidebar} 
          isSidebarOpen={isSidebarOpen}
          isMobile={isMobile}
        />
        
        {/* Content Wrapper */}
        <div
          className={`content-wrapper ${
            !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
          }`}
          style={{
            marginLeft: (!isMobile && isSidebarOpen) ? "" : "0",
            transition: "margin-left 0.3s ease"
          }}
        >
        <section className="content mt-2">
          <div className="d-flex flex-wrap justify-content-between mt-2 p-1 tophead">
            <div className="d-flex align-items-center cursor-pointer justify-content-center">
              <div className="top px-2 fs-3">Withdraw History</div>
            </div>
            <button
              type="button"
              className="btn btn-sm btn-primary refreshButton px-3 py-1 m-2"
              onClick={() => setRefresh(!refresh)}
            >
              Refresh
            </button>
          </div>

          {/* Filters */}
          <div className="d-flex flex-wrap gap-3 align-items-center my-3">
             
              <input
              type="text"
              className="form-control p-3"
              style={{ minWidth: 250 }}
              placeholder="Search by Transaction ID or Phone"
              value={searchText}
              onChange={handleSearchChange}
              />
  
            
            <div>
              <label htmlFor="from" >From:</label>
              <input
              type="date"
              className="form-control p-3"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              max={endDate || ""}
              id="from"
              placeholder="Start Date"
            />
            </div>
            
            <div>
               <label htmlFor="to" >To:</label>
              <input
              type="date"
              className="form-control p-3"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              min={startDate || ""}
              placeholder="End Date"
              id="to"
            />
            </div>

            <div>
               <label htmlFor="status" >Status Type</label>
              <select
              className="form-select"
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              style={{ minWidth: 150 }}
              id="status"
            >
              <option value="">All Status</option>
              <option value="1">Success</option>
              <option value="0">Reject</option>
            </select>
            </div>
            
            <button 
              className="btn btn-primary px-4 py-2" 
              onClick={handleFilter}
            >
              Filter
            </button>
            <button
              className="btn btn-secondary px-4 py-2"
              onClick={() => {
                // Reset all filters and show all
                setSearchText("");
                setStartDate("");
                setEndDate("");
                setStatusFilter("");
                setFilteredWithdraw(withdraw);
              }}
            >
              Reset
            </button>
          </div>

          <div className="table-responsive">
            <table
              role="grid"
              className="table table-hover datatable table-striped mt-4"
            >
              <thead className="bg-dark text-white">
                <tr>
                  <th className="text-center">ID</th>
                  <th className="text-center">Account</th>
                  <th className="text-center">Bank</th>
                  <th className="text-center">Amount</th>
                  <th className="text-center">Transaction Id</th>
                  <th className="text-center">Proof</th>
                  <th className="text-center">Status</th>
                  <th className="text-center">Time</th>
                </tr>
              </thead>
              <tbody>
                {filteredWithdraw.length > 0 ? (
                  filteredWithdraw.map((draw) => (
                    <tr key={draw.id}>
                      <td className="text-center">{draw.id}</td>
                      <td className="text-center">{draw.phone}</td>
                      <td className="text-center">{draw.name_bank}</td>
                      <td className="text-center">{draw.money}</td>
                      <td className="text-center">{draw.id_order}</td>
                      <td className="text-center">
                        <button 
                          className="btn btn-sm btn-info"
                          onClick={() => handleImageClick(draw.proof_image)}
                          title="View Proof Image"
                        >
                          <FontAwesomeIcon icon={faImage} />
                        </button>
                      </td>
                      <td className="text-center">
                        <span
                          style={{
                            backgroundColor: draw.status === 1 ? "green" : "red",
                            color: "#fff",
                            textAlign: "center",
                            paddingLeft: "10px",
                            paddingRight: "10px",
                            borderRadius: "0.5rem",
                          }}
                        >
                          {draw.status === 1 ? "Success" : "Reject"}
                        </span>
                      </td>
                      <td>{timerJoin(draw.time)}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={8} className="text-center">
                      No records found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </section>
      </div>
     
      {/* Image Modal */}
      {showImageModal && (
        <div className="modal show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Transaction Proof</h5>
                <button type="button" className="btn-close" onClick={closeImageModal}></button>
              </div>
              <div className="modal-body text-center">
                {selectedImage ? (
                  <img 
                    src={selectedImage} 
                    alt="Transaction Proof" 
                    className="img-fluid"
                    style={{ maxHeight: '70vh' }}
                    onError={(e) => {
                      console.error("Image failed to load:", e.target.src);
                      e.target.src = "/api/placeholder/400/300";
                      e.target.alt = "Image not available";
                    }}
                  />
                ) : (
                  <div className="alert alert-warning">Image not available</div>
                )}
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={closeImageModal}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default WithdrawHistory;
